'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const mockReturnReasons = [{
  name: 'Did Not Fit',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542731',
  childIds: ['com.narvar.returns|ReturnItemReason|v1|1542743', 'com.narvar.returns|ReturnItemReason|v1|1542744']
}, {
  name: 'Too Small',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542743',
  childIds: null
}, {
  name: 'Too Big',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542744',
  childIds: null
}, {
  name: 'Color Not As Expected',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542732',
  childIds: null
}, {
  name: 'Material Not As Expected',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542733',
  childIds: null
}, {
  name: 'Incorrect Item / Damaged',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542734',
  childIds: null
}, {
  name: 'Other',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542736',
  childIds: null
}, {
  name: 'Arrived Too Late',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542741',
  childIds: null
}, {
  name: 'Changed Mind',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542742',
  childIds: null
}, {
  name: 'Other - Comments Undefined',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542745',
  childIds: null
}, {
  name: 'Other - Comments Not Allowed',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542746',
  childIds: null,
  comments: {
    allowed: false,
    required: false
  }
}, {
  name: 'Other - Comments Allowed',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542747',
  childIds: null,
  comments: {
    allowed: true,
    required: false
  }
}, {
  name: 'Other - Comments Allowed and Required',
  id: 'com.narvar.returns|ReturnItemReason|v1|1542748',
  childIds: null,
  comments: {
    allowed: true,
    required: true
  }
}];
const mockOrderItems = [{
  name: 'Narvar Timbukt2 backpack',
  sku: '',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 75,
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/Narvar_Pack_1_b90f9b31-ea09-45a5-8edd-c84718108adf.png?v=1532034039',
  availableReasons: mockReturnReasons,
  availableReturnActions: [],
  price: {
    value: 20000,
    currency: 'USD'
  },
  eligibilities: {
    exchange: {
      isEligible: false
    },
    repair: {
      isEligible: false
    },
    return: {
      isEligible: false
    }
  }
}, {
  name: 'Narvar Hoodie',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 44,
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/hoodie1.png?v=153203403',
  availableReasons: mockReturnReasons,
  availableReturnActions: [],
  price: {
    value: 1999,
    currency: 'USD'
  },
  eligibilities: {
    exchange: {
      isEligible: true
    },
    repair: {
      isEligible: true
    },
    return: {
      isEligible: true
    }
  }
}, {
  name: 'Narwhal Plushie',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 87,
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/Narwhal_1.png?v=1532034034',
  availableReasons: mockReturnReasons,
  availableReturnActions: [],
  price: {
    value: 599,
    currency: 'USD'
  },
  eligibilities: {
    exchange: {
      isEligible: true
    },
    repair: {
      isEligible: true
    },
    return: {
      isEligible: true
    }
  }
}, {
  name: 'Narvar T Shirt',
  sku: '4303993778415856',
  itemId: '9734007954',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 65,
  availableReturnActions: [],
  price: {
    value: 999,
    currency: 'USD'
  },
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/tshirt.png?v=1532034013',
  availableReasons: mockReturnReasons,
  eligibilities: {
    exchange: {
      isEligible: true
    },
    repair: {
      isEligible: true
    },
    return: {
      isEligible: true
    }
  },
  size: 'XL',
  color: 'blue'
}, {
  name: 'Narvar T Shirt',
  sku: '4303993778415856',
  itemId: '9734007954',
  remainingQuantity: 65,
  quantity: 65,
  orderedQuantity: 65,
  availableReturnActions: [],
  price: {
    value: 999,
    currency: 'USD'
  },
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/tshirt.png?v=1532034013',
  availableReasons: mockReturnReasons === null || mockReturnReasons === void 0 ? void 0 : mockReturnReasons.slice(3),
  eligibilities: {
    exchange: {
      isEligible: false
    },
    repair: {
      isEligible: false
    },
    return: {
      isEligible: true
    }
  },
  size: 'XL',
  color: 'blue'
}];
const mockExchangeVariants = [{
  productId: 'gid://shopify/Product/246874832905',
  variantId: 'gid://shopify/ProductVariant/32095323422831',
  name: 'Narvar Hoodie',
  price: {
    value: 1999,
    currency: 'USD'
  },
  sku: '',
  size: 'small',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/hoodie1.png?v=153203403',
  variantInfo: {
    product: {
      optionId: 'product',
      optionName: 'Product',
      optionPosition: 0,
      value: 'hoodie',
      name: 'Narvar Hoodie',
      position: 0
    },
    size: {
      optionId: 'size',
      optionName: 'Size',
      optionPosition: 1,
      value: 'small',
      name: 'S',
      position: 0
    }
  },
  available: true,
  availabilityStatus: 'In Stock'
}, {
  productId: 'gid://shopify/Product/246874832905',
  variantId: 'gid://shopify/ProductVariant/32095323455599',
  name: 'Narvar Hoodie',
  price: {
    value: 1999,
    currency: 'USD'
  },
  sku: '',
  size: 'medium',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/hoodie1.png?v=153203403',
  variantInfo: {
    product: {
      optionId: 'product',
      optionName: 'Product',
      optionPosition: 0,
      value: 'hoodie',
      name: 'Narvar Hoodie',
      position: 0
    },
    size: {
      optionId: 'size',
      optionName: 'Size',
      optionPosition: 1,
      value: 'medium',
      name: 'M',
      position: 1
    }
  },
  available: true,
  availabilityStatus: 'In Stock'
}, {
  productId: 'gid://shopify/Product/246874832905',
  variantId: 'gid://shopify/ProductVariant/32095323488367',
  name: 'Narvar Hoodie',
  price: {
    value: 1999,
    currency: 'USD'
  },
  sku: '',
  size: 'large',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/hoodie1.png?v=153203403',
  variantInfo: {
    product: {
      optionId: 'product',
      optionName: 'Product',
      optionPosition: 0,
      value: 'hoodie',
      name: 'Narvar Hoodie',
      position: 0
    },
    size: {
      optionId: 'size',
      optionName: 'Size',
      optionPosition: 1,
      value: 'large',
      name: 'L',
      position: 2
    }
  },
  available: true,
  availabilityStatus: 'In Stock'
}, {
  productId: 'gid://shopify/Product/246874832905',
  variantId: 'gid://shopify/ProductVariant/32095323521135',
  name: 'Narvar T Shirt',
  price: {
    value: 999,
    currency: 'USD'
  },
  sku: '',
  size: 'small',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/tshirt.png?v=1532034013',
  variantInfo: {
    product: {
      optionId: 'product',
      optionName: 'Product',
      optionPosition: 0,
      value: 'teeshirt',
      name: 'Narvar T Shirt',
      position: 1
    },
    size: {
      optionId: 'size',
      optionName: 'Size',
      optionPosition: 1,
      value: 'small',
      name: 'S',
      position: 0
    }
  },
  available: true,
  availabilityStatus: 'Only 3 Left'
}, {
  productId: 'gid://shopify/Product/246874832905',
  variantId: 'gid://shopify/ProductVariant/32095323553903',
  name: 'Narvar T Shirt',
  price: {
    value: 999,
    currency: 'USD'
  },
  sku: '',
  size: 'medium',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/tshirt.png?v=1532034013',
  variantInfo: {
    product: {
      optionId: 'product',
      optionName: 'Product',
      optionPosition: 0,
      value: 'teeshirt',
      name: 'Narvar T Shirt',
      position: 1
    },
    size: {
      optionId: 'size',
      optionName: 'Size',
      optionPosition: 1,
      value: 'medium',
      name: 'M',
      position: 1
    }
  },
  available: true,
  availabilityStatus: 'In Stock'
}, {
  productId: 'gid://shopify/Product/246874832905',
  variantId: 'gid://shopify/ProductVariant/32095323619439',
  name: 'Narvar T Shirt',
  price: {
    value: 999,
    currency: 'USD'
  },
  sku: '',
  size: 'large',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/tshirt.png?v=1532034013',
  variantInfo: {
    product: {
      optionId: 'product',
      optionName: 'Product',
      optionPosition: 0,
      value: 'teeshirt',
      name: 'Narvar T Shirt',
      position: 1
    },
    size: {
      optionId: 'size',
      optionName: 'Size',
      optionPosition: 1,
      value: 'large',
      name: 'L',
      position: 2
    }
  },
  available: false,
  availabilityStatus: 'Out of Stock'
}];
const mockTimeSlot = props => ({
  earliestArrival: '2022-07-14T09:00:00.000-07:00',
  latestArrival: '2022-07-14T16:00:00.000-07:00',
  ...props
});
({
  timeSlots: [mockTimeSlot(), mockTimeSlot({
    earliestArrival: '2022-07-15T09:00:00.000-07:00',
    latestArrival: '2022-07-15T16:00:00.000-07:00'
  })],
  handoffTypes: ['FRONT_DESK', 'IN_PERSON']
});
const mockOrderDataItems = [{
  name: 'Narvar T Shirt',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 76,
  price: {
    value: 7807,
    currency: null
  },
  description: '9gOFklOf',
  eligibilities: {
    exchange: {
      isEligible: true,
      message: 'Default'
    },
    repair: {
      isEligible: true,
      message: 'Item is Eligible for Repair'
    },
    return: {
      isEligible: true,
      message: 'Default'
    }
  },
  sku: '4303993778415856',
  itemId: '9734007954',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/tshirt.png?v=1532034013',
  availableReasons: [{
    id: 'com.narvar.returns|ReturnItemReason|v1|1542731',
    name: 'Did Not Fit',
    childIds: null
  }, {
    id: '8bacf944b665623572de840c08e380c3',
    name: 'Color Not As Expected',
    childIds: null
  }, {
    id: '268ade23abcc8d9638ed9df959ff74b1',
    name: 'Material Not As Expected',
    childIds: null
  }, {
    id: 'a702a77e9cc4281bd8a59864e59a40c8',
    name: 'Incorrect Item / Damaged',
    childIds: null
  }, {
    id: 'e91f2d1d91c1d9a42fd9737cabf234f8',
    name: 'Other',
    childIds: null
  }, {
    id: 'a43551736078048de6dc7cbe381c689e',
    name: 'Arrived Too Late',
    childIds: null
  }, {
    id: 'cd588962ae8e7afed961c18bed17e18e',
    name: 'Changed Mind',
    childIds: null
  }],
  availableReturnActions: []
}, {
  name: 'Narvar Timbukt2 backpack',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 14,
  price: {
    value: 29083,
    currency: null
  },
  description: '8aCSm9ci',
  eligibilities: {
    exchange: {
      isEligible: true,
      message: 'Default'
    },
    repair: {
      isEligible: true,
      message: 'Item is Eligible for Repair'
    },
    return: {
      isEligible: true,
      message: 'Default'
    }
  },
  sku: '0350413148925421',
  itemId: '9446857403',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/Narvar_Pack_1_b90f9b31-ea09-45a5-8edd-c84718108adf.png?v=1532034039',
  availableReasons: [{
    id: '56667fe5836ac1996704814b18b760e4',
    name: 'Did Not Fit',
    childIds: null
  }, {
    id: '8bacf944b665623572de840c08e380c3',
    name: 'Color Not As Expected',
    childIds: null
  }, {
    id: '268ade23abcc8d9638ed9df959ff74b1',
    name: 'Material Not As Expected',
    childIds: null
  }, {
    id: 'a702a77e9cc4281bd8a59864e59a40c8',
    name: 'Incorrect Item / Damaged',
    childIds: null
  }, {
    id: 'e91f2d1d91c1d9a42fd9737cabf234f8',
    name: 'Other',
    childIds: null
  }, {
    id: 'a43551736078048de6dc7cbe381c689e',
    name: 'Arrived Too Late',
    childIds: null
  }, {
    id: 'cd588962ae8e7afed961c18bed17e18e',
    name: 'Changed Mind',
    childIds: null
  }],
  availableReturnActions: []
}, {
  name: 'Narwhal Plushie',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 14,
  price: {
    value: 16100,
    currency: null
  },
  description: '1Uub5XDt',
  eligibilities: {
    exchange: {
      isEligible: true,
      message: 'Default'
    },
    repair: {
      isEligible: true,
      message: 'Item is Eligible for Repair'
    },
    return: {
      isEligible: true,
      message: 'Default'
    }
  },
  sku: '5509610811798513',
  itemId: '3639532042',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/Narwhal_1.png?v=1532034034',
  availableReasons: [{
    id: '56667fe5836ac1996704814b18b760e4',
    name: 'Did Not Fit',
    childIds: null
  }, {
    id: '8bacf944b665623572de840c08e380c3',
    name: 'Color Not As Expected',
    childIds: null
  }, {
    id: '268ade23abcc8d9638ed9df959ff74b1',
    name: 'Material Not As Expected',
    childIds: null
  }, {
    id: 'a702a77e9cc4281bd8a59864e59a40c8',
    name: 'Incorrect Item / Damaged',
    childIds: null
  }, {
    id: 'e91f2d1d91c1d9a42fd9737cabf234f8',
    name: 'Other',
    childIds: null
  }, {
    id: 'a43551736078048de6dc7cbe381c689e',
    name: 'Arrived Too Late',
    childIds: null
  }, {
    id: 'cd588962ae8e7afed961c18bed17e18e',
    name: 'Changed Mind',
    childIds: null
  }],
  availableReturnActions: []
}, {
  name: 'Narvar Hoodie',
  remainingQuantity: 1,
  quantity: 1,
  orderedQuantity: 35,
  price: {
    value: 232,
    currency: null
  },
  description: '8bMskPYr',
  eligibilities: {
    exchange: {
      isEligible: true,
      message: 'Default'
    },
    repair: {
      isEligible: true,
      message: 'Item is Eligible for Repair'
    },
    return: {
      isEligible: true,
      message: 'Default'
    }
  },
  sku: '3760533237616211',
  itemId: '2910365803',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0020/4049/6187/products/hoodie1.png?v=153203403',
  availableReasons: [{
    id: '56667fe5836ac1996704814b18b760e4',
    name: 'Did Not Fit',
    childIds: null
  }, {
    id: '8bacf944b665623572de840c08e380c3',
    name: 'Color Not As Expected',
    childIds: null
  }, {
    id: '268ade23abcc8d9638ed9df959ff74b1',
    name: 'Material Not As Expected',
    childIds: null
  }, {
    id: 'a702a77e9cc4281bd8a59864e59a40c8',
    name: 'Incorrect Item / Damaged',
    childIds: null
  }, {
    id: 'e91f2d1d91c1d9a42fd9737cabf234f8',
    name: 'Other',
    childIds: null
  }, {
    id: 'a43551736078048de6dc7cbe381c689e',
    name: 'Arrived Too Late',
    childIds: null
  }, {
    id: 'cd588962ae8e7afed961c18bed17e18e',
    name: 'Changed Mind',
    childIds: null
  }],
  availableReturnActions: []
}];
const mockReturnItemInput = _ref => {
  let {
    name,
    price,
    sku,
    itemId,
    imageUrl,
    availableReasons,
    remainingQuantity
  } = _ref;
  return {
    name,
    quantity: remainingQuantity,
    price,
    sku,
    itemId,
    imageUrl,
    reason: {
      id: (availableReasons === null || availableReasons === void 0 ? void 0 : availableReasons[0].id) || ''
    }
  };
};
mockOrderDataItems.map(mockReturnItemInput);
const mockExtendedReturnItemInput = _ref2 => {
  let {
    name,
    price,
    sku,
    itemId,
    imageUrl,
    availableReasons,
    remainingQuantity
  } = _ref2;
  return {
    name,
    quantity: remainingQuantity,
    price,
    sku,
    itemId,
    imageUrl,
    reason: {
      id: (availableReasons === null || availableReasons === void 0 ? void 0 : availableReasons[0].id) || ''
    },
    exchangeTo: mockExchangeVariants[0]
  };
};
mockOrderDataItems.map(mockExtendedReturnItemInput);

exports.mockExchangeVariants = mockExchangeVariants;
exports.mockExtendedReturnItemInput = mockExtendedReturnItemInput;
exports.mockOrderDataItems = mockOrderDataItems;
exports.mockOrderItems = mockOrderItems;
exports.mockReturnItemInput = mockReturnItemInput;
exports.mockReturnReasons = mockReturnReasons;
exports.mockTimeSlot = mockTimeSlot;
